import React, { forwardRef } from 'react';

const HtmlPreview = forwardRef(({ content }, ref) => {
  return (
    <div ref={ref} style={{ width: '100%', border: '1px solid #ccc', padding: '10px' }} dangerouslySetInnerHTML={{ __html: content }} />
  );
});

export default HtmlPreview;
